import React, { useState, useEffect } from 'react'
import { Modal, Button } from 'semantic-ui-react';
import { useTextResources } from '../../../language';
import PropTypes from "prop-types";
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import './style.css'

export const HtmlEditor = props=>{

  return <ReactQuill theme="snow" {...props}/>
}

const HtmlEditorPopup = ({ startOpen, onSave, onCancel, value, title, ...rest }) => {
    const text = useTextResources()
    const [open, setOpen] = useState(startOpen);
    const [html, setHtml] = useState()

    useEffect(()=>{
        setOpen(startOpen)
    }, [startOpen])

    const closeAction = ()=>{
        setOpen(false)
        if (onCancel) {
            onCancel()
        }
    }

    const saveAction = ()=>{
        setOpen(false)
        if (onSave) {
            onSave(html)
        }
    }

    return <Modal open={open} {...rest} >
        <Modal.Header>{title}</Modal.Header>
        <Modal.Content>
        <HtmlEditor defaultValue={value} onChange={setHtml}  style={{ height: "14em" }}/>
        </Modal.Content>
        <Modal.Actions>
            <Button size={"small"} negative onClick={closeAction}>{text("Cancel")}</Button>
            <Button size={"small"} positive onClick={saveAction}>{text("Save")}</Button>
        </Modal.Actions>
    </Modal>
}

HtmlEditorPopup.propTypes = {
    startOpen: PropTypes.bool,
    onSave: PropTypes.func,
    title: PropTypes.any,
    value: PropTypes.string,
    onCancel: PropTypes.func
}
HtmlEditor.propTypes = {
    value: PropTypes.string,
    onChange: PropTypes.func
}
export default HtmlEditorPopup